import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogTitle from '@mui/material/DialogTitle'
import Slide from '@mui/material/Slide'
import type { TransitionProps } from '@mui/material/transitions'
import React from 'react'
import { i18n } from '../index'

type TransitionComponentProps = TransitionProps & { children: React.ReactElement }

const Transition = React.forwardRef<HTMLElement, TransitionComponentProps>((props, ref) => (
  <Slide direction='up' ref={ref} {...props} />
))

type Props = {
  question: string
  open: boolean
  closeDialog: (...args: Array<any>) => any
}

class ToiletDialog extends React.Component<Props> {
  render() {
    const { question, open, closeDialog } = this.props
    return (
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={closeDialog}
        aria-labelledby='alert-dialog-slide-title'
        aria-describedby='alert-dialog-slide-description'
      >
        <DialogTitle id='alert-dialog-slide-title'>{question}</DialogTitle>
        <DialogActions>
          <Button onClick={closeDialog} color='primary'>
            {i18n.t('buttons.ok')}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default ToiletDialog
